"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DownIcon = exports.UpIcon = exports.DoublePreviousIcon = exports.DoubleNextIcon = exports.PreviousIcon = exports.NextIcon = exports.DeleteIcon = exports.CalendarIcon = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarIcon = function CalendarIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: "1.1",
    x: "0px",
    y: "0px",
    width: "100%",
    height: "100%",
    viewBox: "0 0 36.449 36.448",
    fill: "currentColor",
    stroke: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("rect", {
    x: "12.858",
    y: "14.626",
    width: "4.596",
    height: "4.089"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "18.996",
    y: "14.626",
    width: "4.595",
    height: "4.089"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "25.128",
    y: "14.626",
    width: "4.596",
    height: "4.089"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "6.724",
    y: "20.084",
    width: "4.595",
    height: "4.086"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "12.858",
    y: "20.084",
    width: "4.596",
    height: "4.086"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "18.996",
    y: "20.084",
    width: "4.595",
    height: "4.086"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "25.128",
    y: "20.084",
    width: "4.596",
    height: "4.086"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "6.724",
    y: "25.54",
    width: "4.595",
    height: "4.086"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "12.858",
    y: "25.54",
    width: "4.596",
    height: "4.086"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "18.996",
    y: "25.54",
    width: "4.595",
    height: "4.086"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "25.128",
    y: "25.54",
    width: "4.596",
    height: "4.086"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.974,32.198c0,0.965-0.785,1.75-1.75,1.75h-24c-0.965,0-1.75-0.785-1.75-1.75V12.099h-2.5v20.099 c0,2.343,1.907,4.25,4.25,4.25h24c2.344,0,4.25-1.907,4.25-4.25V12.099h-2.5V32.198z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.224,3.948h-1.098V2.75c0-1.517-1.197-2.75-2.67-2.75c-1.474,0-2.67,1.233-2.67,2.75v1.197h-2.74V2.75 c0-1.517-1.197-2.75-2.67-2.75c-1.473,0-2.67,1.233-2.67,2.75v1.197h-2.74V2.75c0-1.517-1.197-2.75-2.67-2.75 c-1.473,0-2.67,1.233-2.67,2.75v1.197H6.224c-2.343,0-4.25,1.907-4.25,4.25v2h2.5h27.5h2.5v-2 C34.474,5.855,32.568,3.948,30.224,3.948z M11.466,7.646c0,0.689-0.525,1.25-1.17,1.25s-1.17-0.561-1.17-1.25V2.75 c0-0.689,0.525-1.25,1.17-1.25s1.17,0.561,1.17,1.25V7.646z M19.546,7.646c0,0.689-0.525,1.25-1.17,1.25s-1.17-0.561-1.17-1.25 V2.75c0-0.689,0.525-1.25,1.17-1.25s1.17,0.561,1.17,1.25V7.646z M27.626,7.646c0,0.689-0.525,1.25-1.17,1.25 c-0.646,0-1.17-0.561-1.17-1.25V2.75c0-0.689,0.524-1.25,1.17-1.25c0.645,0,1.17,0.561,1.17,1.25V7.646z"
  })));
};

exports.CalendarIcon = CalendarIcon;

var DeleteIcon = function DeleteIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: "1.1",
    width: "100%",
    height: "100%",
    x: "0px",
    y: "0px",
    viewBox: "0 0 469.333 469.333",
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M338.208,131.125c-4.167-4.167-10.917-4.167-15.083,0l-88.458,88.458l-88.458-88.458c-4.167-4.167-10.917-4.167-15.083,0     c-4.167,4.167-4.167,10.917,0,15.083l88.458,88.458l-88.458,88.458c-4.167,4.167-4.167,10.917,0,15.083     c2.083,2.083,4.813,3.125,7.542,3.125s5.458-1.042,7.542-3.125l88.458-88.458l88.458,88.458c2.083,2.083,4.813,3.125,7.542,3.125     c2.729,0,5.458-1.042,7.542-3.125c4.167-4.167,4.167-10.917,0-15.083l-88.458-88.458l88.458-88.458     C342.375,142.042,342.375,135.292,338.208,131.125z"
  })));
};

exports.DeleteIcon = DeleteIcon;

var NextIcon = function NextIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "50%",
    height: "50%",
    viewBox: "6 6 12 12"
  }, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    transform: " scale(-1, 1) translate(-24, 0)"
  }, /*#__PURE__*/_react.default.createElement("polygon", {
    fill: "currentColor",
    points: "10.02 6 8.61 7.41 13.19 12 8.61 16.59 10.02 18 16.02 12"
  })));
};

exports.NextIcon = NextIcon;

var PreviousIcon = function PreviousIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "50%",
    height: "50%",
    viewBox: "6 6 12 12",
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("polygon", {
    points: "10.02 6 8.61 7.41 13.19 12 8.61 16.59 10.02 18 16.02 12"
  })));
};

exports.PreviousIcon = PreviousIcon;

var DoubleNextIcon = function DoubleNextIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "50%",
    height: "50%",
    viewBox: "6 6 12 12",
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "scale(-1, 1) translate(-24, 0)"
  }, /*#__PURE__*/_react.default.createElement("polygon", {
    points: "10.02 6 8.61 7.41 13.19 12 8.61 16.59 10.02 18 16.02 12"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    transform: "translate(5 0)",
    points: "10.02 6 8.61 7.41 13.19 12 8.61 16.59 10.02 18 16.02 12"
  })));
};

exports.DoubleNextIcon = DoubleNextIcon;

var DoublePreviousIcon = function DoublePreviousIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "50%",
    height: "50%",
    viewBox: "6 6 12 12",
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("polygon", {
    points: "10.02 6 8.61 7.41 13.19 12 8.61 16.59 10.02 18 16.02 12"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    transform: "translate(5 0)",
    points: "10.02 6 8.61 7.41 13.19 12 8.61 16.59 10.02 18 16.02 12"
  })));
};

exports.DoublePreviousIcon = DoublePreviousIcon;

var UpIcon = function UpIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "50%",
    height: "50%",
    viewBox: "6 6 12 12",
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(-90 12 12)"
  }, /*#__PURE__*/_react.default.createElement("polygon", {
    points: "10.02 6 8.61 7.41 13.19 12 8.61 16.59 10.02 18 16.02 12"
  })));
};

exports.UpIcon = UpIcon;

var DownIcon = function DownIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "50%",
    height: "50%",
    viewBox: "6 6 12 12",
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(90 12 12)"
  }, /*#__PURE__*/_react.default.createElement("polygon", {
    points: "10.02 6 8.61 7.41 13.19 12 8.61 16.59 10.02 18 16.02 12"
  })));
};

exports.DownIcon = DownIcon;